/**
 * Validates that a value is a zip code. Useful in forms where
 * a user is entering a zip code.
 *
 * @param input value from input field
 * @returns undefined if input is a valid zip code
 * @returns an error message if input is not a valid zip code
 */
export const validateZipInput = (input: string) => {
  const regex = /^\d{5}$/
  return regex.test(input) ? undefined : 'Please enter a valid zip code'
}
